import { createSlice } from '@reduxjs/toolkit';
const selectedWalletMoreInfoSlice = createSlice({
    name: 'wallet_info',
    initialState: {},
    reducers: {
        selectedWalletMoreInfoReducer: {
            reducer: (state, action) => (state = action.payload),
            prepare: (value) => ({ payload: value || [] }),
        },
    },
});

export const { selectedWalletMoreInfoReducer } = selectedWalletMoreInfoSlice.actions;
export default selectedWalletMoreInfoSlice.reducer;